import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";

@Component({
  selector: "app-project-detail-mobile-list-item",
  templateUrl: "./project-detail-mobile-list-item.component.html",
  styleUrls: ["./project-detail-mobile-list-item.component.scss"],
  standalone: true,
  imports: [UiKitModule],
})
export class ProjectDetailMobileListItemComponent {
  @Input({ required: true }) title!: string;
  @Input() expanded = false;

  @Output() toggle$ = new EventEmitter<void>();

  onToggle() {
    this.toggle$.emit();
  }
}
